import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[libDatepickerHost]',
    standalone: true
})
export class DatepickerHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
